module.exports = __webpack_public_path__ + "static/media/book-health-medical-svgrepo-com.4bb144cd.svg";